/**
 * ActivateCircleIcon Component
 *
 * Circle outline with a filled checkmark, sized for 24px dialog-icon
 * contexts. The existing CheckCircleIcon is 14×14 (toast-sized) with
 * thicker relative strokes — this is the design-system variant for
 * larger surfaces like bulk-action confirmation dialogs (GRAIN-1577).
 */

export function ActivateCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="11.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M17.1857 8.6156L9.5155 16.2858L6 12.7703L6.90125 11.869L9.5155 14.4769L16.2844 7.71436L17.1857 8.6156Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
}
